<template>
	<Pupup @close="closePupup" :showClose="true" :width="1000" :full="false" :shuffleUp="true">
		<template v-slot:content>
			<div class="collab-pupup-content-wrap" v-if="collabInfoLoaded">
				<h2 class="underline main-title">
					<span>{{ title }}</span>
				</h2>
				<div class="content-wrap">
					<div class="benefits">
						<div class="img"><img :src="image" v-if="image" /></div>
						<div>
							<div>
								<h2 class="effort-heading">Effort Involved</h2>
								<h3 class="effort" v-html="effort" />
							</div>
							<h2 class="great">Why is this a great collab?</h2>
							<div class="icons">
								<div v-for="(benefit, index) in benefits" :key="'benefit-' + index" class="icon-wrap">
									<Icon :type="index" class="icon" colour="#679da2" />
									<span>{{ benefit }}</span>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="main-content" v-html="content" />
						<div class="examples" v-if="examples.length > 0">
							<h3 v-html="examplesTitle" class="examples-title" />
							<div class="examples-wrap">
								<div v-for="(example, index) in examples" :key="'example-' + index" class="example">
									<a :href="example.link" target="_blank" v-if="example.link"><img :src="example.image" /></a>
									<img :src="example.image" v-else />
								</div>
							</div>
						</div>
						<div class="template-info" v-html="template_info" v-if="template_info" />
					</div>
				</div>
			</div>
		</template>
	</Pupup>
</template>

<script>
import { computed, onMounted, getCurrentInstance } from "vue";
import Pupup from "./../Display/Pupup.vue";
import Icon from "./../Display/BaseIcon.vue";

export default {
	name: "CollabPupup",
	components: { Pupup, Icon },
	props: {
		slug: {
			type: String,
			required: true,
		},
	},
	setup(props, { emit }) {
		const vm = getCurrentInstance().proxy;
		const store = vm.$store;

		const collabInfo = computed(() => store.state.general.collabInfo);
		const collabInfoLoaded = computed(() => store.state.general.collabInfoLoaded);

		const info = computed(() => {
			if (!collabInfoLoaded.value) return null;
			return collabInfo.value.list.find((type) => type.slug === props.slug);
		});

		const benefits = computed(() => {
			if (!info.value) return {};
			let benefits = {};
			info.value.benefits.forEach((benefit) => {
				benefits[benefit] = collabInfo.value.benefits[benefit];
			});
			return benefits;
		});

		const image = computed(() => {
			return info.value ? info.value.image || "" : "";
		});

		const title = computed(() => {
			return collabInfoLoaded.value && info.value ? info.value.title : "Loading...";
		});

		const template_info = computed(() => {
			return collabInfoLoaded.value && info.value ? info.value.template_info.trim() : "";
		});

		const content = computed(() => {
			return collabInfoLoaded.value && info.value ? info.value.content : "";
		});

		const examples = computed(() => {
			return collabInfoLoaded.value && info.value ? info.value.examples : [];
		});

		const examplesTitle = computed(() => {
			if (!info.value) return "Examples...";
			return info.value.example_title ? info.value.example_title : "Examples...";
		});

		const effort = computed(() => {
			if (!info.value) return "";
			switch (info.value.effort) {
				case "minimal":
					return "Minimal Effort";
				case "some":
					return "Some Effort";
				case "maximum":
					return "Maximum Effort";
			}
			return "";
		});

		const loadCollabIdeas = () => store.dispatch("general/loadCollabIdeas");

		const closePupup = () => {
			emit("close");
		};

		onMounted(() => {
			loadCollabIdeas();
		});

		return {
			collabInfoLoaded,
			title,
			image,
			effort,
			benefits,
			content,
			examples,
			examplesTitle,
			template_info,
			closePupup,
		};
	},
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";

.pupup-footer-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 40px;
	background-color: @formDefaultColour;
	position: absolute;
	bottom: 0;
	left: 0;
}
</style>
<style lang="less">
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";

.collab-pupup-content-wrap {
	margin: 0;

	.main-title {
		margin: 0 30px 20px 0;
	}

	.examples {
		margin: 30px 0;

		.examples-title {
			color: @formDefaultColour;
		}

		.examples-wrap {
			.example {
				overflow: hidden;
				margin-bottom: 30px;

				img {
					max-width: calc(100% - 8px);
					display: block;
					border: 4px solid fade(@formDefaultColour, 50%);
					.rounded(5px);
				}
			}
		}
	}

	.benefits {
		background-color: fade(@formDefaultColour, 8%);
		padding: 30px;
		margin-bottom: 30px;
		border: 1px solid fade(@formDefaultColour, 30%);
		.rounded(5px);

		p,
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			color: @formDefaultColour;
			text-align: center;
			line-height: 1.3em;
			padding: 0;
			margin: 0;
		}

		.great {
			padding-top: 30px;
		}

		.effort-heading {
			padding-top: 35px;
		}

		.effort {
			padding-top: 15px;
		}

		.icons {
			margin-top: 10px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
		}

		.icon-wrap {
			margin: 20px 10px 0;
			width: 30%;

			.icon {
				width: auto;
				height: 30px;
				margin: 0 auto 10px;
				display: block;
			}

			span {
				color: @formDefaultColour;
				display: block;
				text-align: center;
				font-size: 14px;
			}
		}

		img {
			.rounded(5px);
			display: block;
			max-width: 400px;
			width: 100%;
			margin: 0 auto;
		}
	}

	.template-info {
		color: @guidedRose;
		border: 1px solid fade(@guidedRose, 50%);
		.rounded(5px);
		padding: 20px;
		margin-top: 30px;

		h1,
		h2,
		h3,
		h4,
		h5,
		h6,
		li,
		p {
			color: inherit;
		}
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	li {
		margin-bottom: 10px;
	}

	p,
	li {
		line-height: 1.6em;
	}

	p {
		margin: 0 0 20px;

		&:last-child {
			margin-bottom: 0;
		}

		strong {
			color: @formDefaultColour;
		}
	}

	a {
		color: @guidedRose;
		text-decoration: underline;

		&:hover {
			text-decoration: none;
		}
	}
}
@media screen and (min-width: 768px) {
	.collab-pupup-content-wrap {
		.examples {
			margin-bottom: 0;

			.examples-wrap {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.example {
					width: 49%;
					margin: 2% 0 0;

					&:nth-child(1),
					&:nth-child(2) {
						margin-top: 0;
					}
				}
			}
		}
	}
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.collab-pupup-content-wrap {
		.content-wrap {
			.benefits {
				display: flex;

				.img {
					width: 50%;
					flex-grow: 0;
					flex-shrink: 0;
				}

				.effort-heading {
					padding-top: 15px;
				}
			}
		}
	}
}

@media screen and (min-width: 1024px) {
	.collab-pupup-content-wrap {
		.main-title {
			margin: 0 0 15px;
		}

		.content-wrap {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
		}

		.main-content {
			margin-top: 10px;
		}

		.benefits {
			order: 1;
			margin: 0 0 0 30px;
			padding: 15px 15px 40px;
			width: 260px;
			flex-shrink: 0;
			flex-grow: 0;

			.great {
				padding-top: 40px;
			}

			.icons {
				margin-top: 0;
			}

			.icon-wrap {
				margin: 40px 0 0;
				width: 34%;
			}
		}
	}
}
</style>